import { HunterPrerequisiteType } from "Infrastructure/Api/Api";
import { useHunterPrerequisitesQuery } from "Api/Queries/Hunter/useHunterPrerequisitesQuery";
import { HunterPrerequisitesWidget } from "Components/Hunter/Prerequisites/HunterPrerequisitesWidget";
import { HunterPrerequisitesWidgetSkeleton } from "Components/Hunter/Prerequisites/HunterPrerequisitesWidgetSkeleton";
import type {
  HunterPrerequisiteItem,
  PrerequisiteItemLink,
} from "Components/Hunter/Prerequisites/types";
import { Resources, useResource } from "Translations/Resources";
import { HunterPrerequisitesWidgetError } from "Components/Hunter/Prerequisites/HunterPrerequisitesWidgetError";

const ITEM_RESOURCES = Resources.Hunter.Dashboard.Prerequisites.Items;

export const HunterPrerequisitesWidgetContainer = () => {
  const {
    data: prerequisites,
    isLoading,
    isError,
  } = useHunterPrerequisitesQuery();
  const { t } = useResource();

  if (isLoading) {
    return <HunterPrerequisitesWidgetSkeleton />;
  }

  if (isError || !prerequisites) {
    return <HunterPrerequisitesWidgetError />;
  }

  const itemConfigs: Record<
    HunterPrerequisiteType,
    { description: string; link?: PrerequisiteItemLink }
  > = {
    [HunterPrerequisiteType.RegisterAsMerchant]: {
      description: t(ITEM_RESOURCES.RegisterAsMerchant),
    },
    [HunterPrerequisiteType.InviteUserViaAffiliate]: {
      description: t(ITEM_RESOURCES.InviteUserViaAffiliate),
    },
    [HunterPrerequisiteType.BanksAndPayments]: {
      description: t(ITEM_RESOURCES.BanksAndPayments),
    },
    [HunterPrerequisiteType.OfflineTraining]: {
      description: t(ITEM_RESOURCES.OfflineTraining),
      link: {
        text: t(ITEM_RESOURCES.OfflineTrainingLink),
        href: t(ITEM_RESOURCES.OfflineTrainingUrl),
        external: true,
      },
    },
    [HunterPrerequisiteType.BringMerchantsWithHunter]: {
      description: t(ITEM_RESOURCES.BringMerchantsWithHunter),
    },
  };

  const prerequisiteItems: Array<HunterPrerequisiteItem> =
    prerequisites.items.map(({ prerequisiteType, completionStatus }) => {
      const config = itemConfigs[prerequisiteType] ?? {
        description: prerequisiteType,
      };

      return {
        id: prerequisiteType,
        completionStatus,
        ...config,
      };
    });

  return <HunterPrerequisitesWidget items={prerequisiteItems} />;
};
